<template>
  <div>
    <b-form @submit="onSubmit">
      <b-form-group>
        <table class="table table-bordered">
          <tr v-for="(option, index) in options" :key="index">
            <td class="carrier-column-radio">
              <b-form-radio
                :value="option"
                v-model="selected_delivery"
                v-on:change="handleRadioChange"
                class="align-middle"
              ></b-form-radio>
            </td>
            <td class="carrier-column-logo">
              <PictureFallback
                :src="option.carrier.logo"
                type="carrier"
                class="p-2 carrier-logo align-middle text-center"
              />
            </td>
            <td>
              <span class="carrier-name">{{ option.carrier.name }}</span>
              <span
                v-if="option.external_service_product_name"
                class="carrier-name"
              >
                {{ option.external_service_product_name }}
              </span>
              <div v-if="option.temporary_delivery_date" class="mt-2">
                {{ $t("checkout_control_delivery.delivery_date") }}:
                {{ i18nFormatDate(option.temporary_delivery_date) }}
              </div>
            </td>
            <td>
              {{ deliveryTotalCost(option) }}
            </td>
          </tr>
        </table>

        <b-row>
          <b-col cols="12" class="text-right">
            <b-button type="submit" variant="primary">{{
              $t("checkout_control_delivery.confirm")
            }}</b-button>
          </b-col>
        </b-row>
      </b-form-group>
    </b-form>
  </div>
</template>

<script>
import PictureFallback from "@/components/PictureFallback";

export default {
  name: "checkout-control-delivery",
  components: {
    PictureFallback,
  },
  props: {
    options: {
      type: Array,
      default: undefined,
    },
  },
  data() {
    return {
      selected_delivery: undefined,
    };
  },
  methods: {
    handleRadioChange(_delivery) {
      var delivery = Object.assign({}, _delivery);
      this.selected_delivery = delivery;
    },
    onSubmit(evt) {
      evt.preventDefault();
      this.$emit("input", this.selected_delivery);
    },
    deliveryTotalCost(option) {
      if (option.delivery_costs.length > 0) {
        const total = option.delivery_costs.reduce(
          (total, cost) => total + Number(cost.static_increment),
          0
        );
        return this.$formatMoney(
          total,
          option.delivery_costs[0].static_increment_currency
        );
      }
    },
  },
  fallbackI18n: {
    messages: {
      und: {
        checkout_control_delivery: {
          confirm: "Confirm",
          delivery_date: "Delivery Date",
        },
      },
    },
  },
};
</script>

<style scoped lang="scss">
.delivery-method {
  border: 1px solid transparent;
}

.delivery-selected {
  background-color: $corp-color2-transparent;
  border: 1px solid $corp-color2;
  border-radius: 5px;
}
.carrier-logo {
  width: 4rem;
}
.carrier-name {
  font-size: $font-size-medium;
  font-weight: bold;
}
.carrier-column-radio {
  vertical-align: middle;
  width: 10%;
  text-align: center;
}
.carrier-column-logo {
  vertical-align: middle;
  width: 10%;
}
</style>
